import { useEffect } from 'react';

/** Keep fixed dialogs inside the screen area left visible by a phone keyboard. */
export function useVisualViewport() {
  useEffect(() => {
    const root = document.documentElement;
    const viewport = window.visualViewport;
    const properties = ['--visual-viewport-height', '--visual-viewport-top', '--visual-viewport-bottom', '--visual-viewport-width', '--visual-viewport-left'];
    const previous = properties.map(name => root.style.getPropertyValue(name));
    const previousKeyboard = root.getAttribute('data-keyboard-open');
    let frame = 0;
    const update = () => {
      const height = viewport?.height ?? window.innerHeight;
      const top = viewport?.offsetTop ?? 0;
      const bottom = Math.max(0, window.innerHeight - height - top);
      root.style.setProperty(properties[0], `${height}px`);
      root.style.setProperty(properties[1], `${top}px`);
      root.style.setProperty(properties[2], `${bottom}px`);
      root.style.setProperty(properties[3], `${viewport?.width ?? window.innerWidth}px`);
      root.style.setProperty(properties[4], `${viewport?.offsetLeft ?? 0}px`);
      const editing = document.activeElement?.matches('input:not([type="checkbox"]):not([type="radio"]), textarea, [contenteditable="true"]');
      root.setAttribute('data-keyboard-open', bottom > 150 && editing ? 'true' : 'false');
    };
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
    update();
    viewport?.addEventListener('resize', schedule);
    viewport?.addEventListener('scroll', schedule);
    window.addEventListener('resize', schedule);
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    return () => {
      cancelAnimationFrame(frame);
      viewport?.removeEventListener('resize', schedule);
      viewport?.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      document.removeEventListener('focusin', schedule);
      document.removeEventListener('focusout', schedule);
      properties.forEach((name, index) => previous[index] ? root.style.setProperty(name, previous[index]) : root.style.removeProperty(name));
      if (previousKeyboard === null) root.removeAttribute('data-keyboard-open');
      else root.setAttribute('data-keyboard-open', previousKeyboard);
    };
  }, []);
}
